import React, { useState } from 'react';
import { Box, Button, Modal, SpaceBetween } from '@cloudscape-design/components';

export default function AssessmentEditButton({ onConfirm, loading = false, disabled = false }) {
  const [visible, setVisible] = useState(false);

  return <>
    <Button onClick={() => setVisible(true)} loading={loading} disabled={disabled}>Edit assessment</Button>
    <Modal
      visible={visible}
      onDismiss={() => setVisible(false)}
      header="Edit assessment"
      closeAriaLabel="Close edit confirmation"
      footer={<Box float="right">
        <SpaceBetween direction="horizontal" size="xs">
          <Button onClick={() => setVisible(false)}>Cancel</Button>
          <Button variant="primary" loading={loading} disabled={disabled} onClick={() => {
            setVisible(false);
            onConfirm();
          }}>Start editing</Button>
        </SpaceBetween>
      </Box>}
    >
      <Box>Are you sure you want to edit this assessment?</Box>
    </Modal>
  </>;
}
